import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-ribbon-reload',
  templateUrl: './ribbon-reload.component.html',
  styleUrls: ['./ribbon-reload.component.scss']
})
export class RibbonReloadComponent implements OnInit {

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

}
